const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

async function postLeadEvent(body) {
  if (!BACKEND_URL) {
    return { ok: false, skipped: true };
  }

  const res = await fetch(`${BACKEND_URL}/api/marketing/lead-events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    keepalive: true,
  });

  if (!res.ok) {
    const detail = await res.text().catch(() => "");
    throw new Error(`lead event failed: ${res.status}${detail ? ` ${detail}` : ""}`);
  }

  return res.json();
}

export function sendLeadEvent({ leadId, engagement, productActivation, occurredAt }) {
  if (!leadId) {
    return Promise.resolve({ ok: false, skipped: true });
  }

  return postLeadEvent({
    lead_id: leadId,
    ...(occurredAt ? { occurred_at: occurredAt } : {}),
    ...(engagement ? { engagement } : {}),
    ...(productActivation ? { product_activation: productActivation } : {}),
  });
}

export function trackVslPageOpened(leadId) {
  return sendLeadEvent({
    leadId,
    engagement: { vsl_page_opened: true },
  });
}

export function trackVideoWatchedPercentage(leadId, percentage) {
  return sendLeadEvent({
    leadId,
    engagement: { video_watched_percentage: percentage },
  });
}
